import Vue from "vue";
import VueRouter from "vue-router";
import { getCookie } from "@/utils/index";

Vue.use(VueRouter);

const prefix = getCookie("reqPrefix") || "";
const car_rental_rules = () =>
	import(
		/* webpackChunkName: "car_rental_rules" */ "../views/terms/car_rental_rules.vue"
	);
const contract = () =>
	import(/* webpackChunkName: "contract" */ "../views/contract.vue");

const routes = [
	{
		path: `${prefix}/`,
		name: "contract",
		component: contract
	},
	{
		path: `${prefix}/other/contract`,
		name: "contract",
		component: contract
	},
	{
		path: `${prefix}/other/gt`,
		name: "gt",
		component: car_rental_rules
	},
	{
		path: `${prefix}/redirect_page`,
		name: "redirectPage",
		component: () => import( /* webpackChunkName: "redirect_page" */ "../views/redirectPage.vue"),
	},
	{
		path: `${prefix}/other/add_driving_license/:token`,
		name: "add_driving",
		meta: {
			title: "h5上传"
		},
		component: () =>
			import(
				/* webpackChunkName: "add_driving" */ "../views/add_driving_license/add_driving_license.vue"
			)
	},
	{
		path: `${prefix}/other/order_detail_print`,
		name: "order_detail_print",
		meta: {
			title: "租赁详情明细"
		},
		component: () =>
			import(
				/* webpackChunkName: "order_detail_print" */ "../views/order_detail_print.vue"
			)
	},
	{
		path: `${prefix}/other/terms/car_rental_rules`,
		meta: {
			title: "租车规则"
		},
		component: car_rental_rules
	},
	{
		path: `${prefix}/other/terms/information_disposal_system`,
		name: "information_disposal_system",
		meta: {
			title: "讯息处置制度"
		},
		component: () =>
			import(
				/* webpackChunkName: "information_disposal_system" */ "../views/terms/information_disposal_system.vue"
			)
	},
	{
		path: `${prefix}/other/terms/privacy_policy`,
		name: "privacy_policy",
		meta: {
			title: "隐私政策"
		},
		component: () =>
			import(
				/* webpackChunkName: "privacy_policy" */ "../views/terms/privacy_policy.vue"
			)
	},
	{
		path: `${prefix}/other/terms/user_agreement`,
		name: "user_agreement",
		meta: {
			title: "用户协议"
		},
		component: () =>
			import(
				/* webpackChunkName: "user_agreement" */ "../views/terms/user_agreement.vue"
			)
	},
	{
		path: `${prefix}/other/terms/terms_and_conditions`,
		name: "terms_and_conditions",
		meta: {
			title: "条款细则"
		},
		component: () =>
			import(
				/* webpackChunkName: "terms_and_conditions" */ "../views/terms/terms_and_conditions.vue"
			)
	},
	{
		path: `${prefix}/other/lease_contract/pc`,
		name: "leaseContract.pc",
		meta: {
			title: "租赁合同"
		},
		component: () =>
			import(
				/* webpackChunkName: "leaseContract.pc" */ "../views/lease_contract/pc.vue"
			)
	},
	{
		path: `${prefix}/other/lease_contract/mobile`,
		name: "leaseContract.mobile",
		meta: {
			title: "租赁合同"
		},
		component: () =>
			import(
				/* webpackChunkName: "leaseContract.mobile" */ "../views/lease_contract/mobile.vue"
			)
	},
	{
		path: `${prefix}/other/lease_contract/template_pdf`,
		name: "leaseContract.template_pdf",
		meta: {
			title: "租赁合同"
		},
		component: () =>
			import(
				/* webpackChunkName: "leaseContract.template_pdf" */ "../views/lease_contract/template_pdf.vue"
			)
	},
	{
		path: `${prefix}/other/lease_contract/design`,
		name: "leaseContract.design",
		meta: {
			title: "签名页"
		},
		component: () =>
			import(
				/* webpackChunkName: "leaseContract.design" */ "../views/lease_contract/design.vue"
			)
	},
	{
		path: `${prefix}/other/lease_contract/authentication`,
		name: "leaseContract.authentication",
		meta: {
			title: "鉴权页"
		},
		component: () =>
			import(
				/* webpackChunkName: "leaseContract.authentication" */ "../views/lease_contract/authentication.vue"
			)
	},
	{
		path: `${prefix}/other/lease_contract/login`,
		name: "leaseContract.login",
		meta: {
			title: "登录页"
		},
		component: () =>
			import(
				/* webpackChunkName: "leaseContract.login" */ "../views/lease_contract/login.vue"
			)
	}
];
console.log("prefix", routes);

const router = new VueRouter({
	mode: "history",
	// base: process.env.BASE_URL,
	routes
});
router.beforeEach((to, from, next) => {
	console.log("to", to);
	router.app.$message && router.app.$message.closeAll();
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	// chrome
	document.body.scrollTop = 0;
	// firefox
	document.documentElement.scrollTop = 0;
	// safari
	window.pageYOffset = 0;
	router.app.$nextTick(() => {
		next();
	});
});
export default router;
